module.exports = __webpack_public_path__ + "img/icon_guide_device.4639c30c.png";